import React, { useState, useRef, useEffect, useContext } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import Swal from "sweetalert2";

function Addjacstudent11() {
  const { setClass11JacStudent } = useContext(ContextBoard);
  const navigate = useNavigate();

  const [year, setYear] = useState("");
  const [yearList, setYearList] = useState([]);

  const [rollCode, setRollCode] = useState("");
  const [rollNumber, setRollNumber] = useState("");
  const [reg1, setReg1] = useState("");
  const [reg2, setReg2] = useState("");
  const [reg3, setReg3] = useState("");

  const [loading, setLoading] = useState(false);

  const reg1Ref = useRef();
  const reg2Ref = useRef();
  const reg3Ref = useRef();

  useEffect(() => {
    const fetchYears = async () => {
      try {
        setLoading(true);
        const token = sessionStorage.getItem("tokenclassxi");

        const response = await fetch(
          `${config.API_BASE_URL}/PageLoadStudentRegYOP_CL11`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLoading(false);
        const data = await response.json();
        // Extracting the year from nested response
        const examYears = data?.data?.studentRegYOP_data?.examYears;
        if (Array.isArray(examYears) && examYears.length > 0) {
          setYearList(examYears.map((item) => item.year).sort((a, b) => b - a));
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch year list:", error);
      }
    };

    fetchYears();
  }, []);

  const handleInput =
    (setter, maxLength, nextRef, prevRef = null) =>
    (e) => {
      const value = e.target.value.replace(/\D/g, "");
      setter(value);
      if (value.length === parseInt(maxLength) && nextRef?.current) {
        nextRef.current.focus();
      }
      if (
        value.length === 0 &&
        prevRef?.current &&
        e.nativeEvent.inputType === "deleteContentBackward"
      ) {
        prevRef.current.focus();
      }
    };

  const handleSubmit = async () => {
    const fullReg = `${reg1}-${reg2}-${reg3}`;

    // ✅ Field-wise validation
    if (!year) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Year is missing.",
        confirmButtonColor: "#00A65A",
      });
      return;
    }
    if (!rollCode) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Roll Code is missing.",
        confirmButtonColor: "#00A65A",
      });
      return;
    }
    if (!rollNumber) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Roll Number is missing.",
        confirmButtonColor: "#00A65A",
      });
      return;
    }
    if (!reg1 || !reg2 || !reg3) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Registration Number is incomplete.",
        confirmButtonColor: "#00A65A",
      });
      return;
    }

    const payload = {
      year,
      rollCode,
      rollNumber,
      registrationNumber: fullReg,
    };

    try {
      setLoading(true);
      const token = sessionStorage.getItem("tokenclassxi");

      const response = await fetch(
        `${config.API_BASE_URL}/FetchJACStudent_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            year: payload.year,
            rolL_CODE: payload.rollCode,
            rolL_NUMBER: payload.rollNumber,
            registratioN_NO: payload.registrationNumber,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result?.data) {
        setClass11JacStudent(result.data.student_list);
        setLoading(false);
        navigate("/class-xi-add-student-jac-page");
      } else {
        setLoading(false);
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: result.message || "Failed to fetch student data.",
          confirmButtonColor: "#00A65A",
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting student data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong. Please try again.",
        confirmButtonColor: "#00A65A",
      });
    }
  };

  return (
    <div className="container-scroller">
      <Navbar11 />
      <div className="container-fluid page-body-wrapper">
        <Sidebar11 />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-1">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-user-plus"></i>&nbsp; Add JAC Student
                    (Student Registration Page for Board Examination)
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/class-xi-dashboard");
                        }}
                      >
                        {" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li className="active"> Add Student (JAC)</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header card-green">
                    <h4 className="mb-0 p-2">Registration Details</h4>
                  </div>
                  <div className="card-body">
                    <div
                      className="row d-flex"
                      style={{ justifyContent: "center" }}
                    >
                      <div className="col-md-10 py-3">
                        {/* Year of Passing */}
                        <div className="row">
                          <label className="col-md-3">Year of Passing:</label>
                          <div className="col-md-2">
                            <select
                              className="form-select form-select-xs"
                              value={year}
                              onChange={(e) => setYear(e.target.value)}
                            >
                              <option value="">Select</option>
                              {yearList.map((yr, idx) => (
                                <option key={idx} value={yr}>
                                  {yr}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* Roll Code */}
                        <div className="row mt-3">
                          <label className="col-md-3">Roll Code:</label>
                          <div className="col-md-3">
                            <input
                              className="form-control form-control-xs"
                              value={rollCode}
                              maxLength="5"
                              onChange={(e) =>
                                setRollCode(e.target.value.replace(/\D/g, ""))
                              }
                            />
                            <p>5 Digits Only</p>
                          </div>
                        </div>

                        {/* Roll Number */}
                        <div className="row mt-3">
                          <label className="col-md-3">Roll Number:</label>
                          <div className="col-md-3">
                            <input
                              className="form-control form-control-xs"
                              value={rollNumber}
                              maxLength="4"
                              onChange={(e) =>
                                setRollNumber(e.target.value.replace(/\D/g, ""))
                              }
                            />
                            <p>4 Digits Only</p>
                          </div>
                        </div>

                        {/* Registration Number */}
                        <div className="row mt-3">
                          <label className="col-md-3">
                            Registration Number :
                          </label>
                          <div className="col-md-2">
                            <input
                              className="form-control form-control-xs"
                              value={reg1}
                              ref={reg1Ref}
                              maxLength="5"
                              onChange={handleInput(setReg1, 5, reg2Ref)}
                            />
                            <p>5 Digits Only</p>
                          </div>
                          <div className="col-md-2">
                            <input
                              className="form-control form-control-xs"
                              value={reg2}
                              ref={reg2Ref}
                              maxLength="5"
                              onChange={handleInput(
                                setReg2,
                                5,
                                reg3Ref,
                                reg1Ref
                              )}
                            />
                            <p>5 Digits Only</p>
                          </div>
                          <div className="col-md-2">
                            <input
                              className="form-control form-control-xs"
                              value={reg3}
                              ref={reg3Ref}
                              maxLength="2"
                              onChange={handleInput(setReg3, 2, null, reg2Ref)}
                            />
                            <p>2 Digits Only</p>
                          </div>
                        </div>

                        {/* Submit */}
                        <div className="row mt-4">
                          <div className="col-md-2"></div>
                          <div className="col-md-8">
                            <div className="row">
                              <div className="col-md-2"></div>
                              <div className="col-md-8">
                                <button
                                  type="button"
                                  onClick={handleSubmit}
                                  className="btn btn-block btn-xs proceed-btn"
                                  style={{
                                    fontSize: "16px",
                                    padding: "8px",
                                    backgroundColor: "#FF0000",
                                    color: "white",
                                    fontWeight: "600",
                                  }}
                                >
                                  CLICK HERE TO VALIDATE & PROCEED
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer11 />
        </div>
      </div>
    </div>
  );
}

export default Addjacstudent11;
